export const HEADER_FIELDS = [
  ['legal_entity', 'Contract (legal entity)'], ['client_name', 'Settlement report (client)'], ['project_code', 'Project ID'],
  ['account_manager', 'Account manager'], ['company_name', 'Company'], ['address_line_1', 'Address 1'], ['address_line_2', 'Address 2'],
  ['address_line_3', 'Address 3'], ['address_line_4', 'Address 4'], ['address_line_5', 'Address 5'], ['contact_email', 'Contact email'],
  ['vat_number', 'VAT number'], ['contract_basis', 'Contract basis'], ['power_contract', 'Power contract'], ['om_terms', 'O&M terms'],
  ['software_licence_terms', 'Software licence terms'], ['payment_terms', 'Payment terms'],
  ['reactive_maintenance_terms', 'Reactive maintenance terms'],
];

/* The account managers shown in the left-hand menu. A report belongs to the one whose first name its account_manager field starts with
 * ("Carol" and "Carol Wilson" both belong to Carol); anything else is listed under "Unassigned". */
export const ACCOUNT_MANAGERS = ['Carol', 'Robyn', 'Jonah'];
export const UNASSIGNED = 'Unassigned';
export const managerOf = (r) => {
  const first = String(r?.account_manager || '').trim().split(/\s+/)[0].toLowerCase();
  return ACCOUNT_MANAGERS.find((n) => n.toLowerCase() === first) || UNASSIGNED;
};
